<template>
    <v-dialog
        v-model="$props.params.sosDialog"
        transition="dialog-bottom-transition"
        max-width="600px"
        @keydown.esc="!showProgressBar ? closeSosDialog() : ''"
        @click:outside="!showProgressBar ? closeSosDialog() : ''"
        :persistent="showProgressBar"
    >
        <v-card>
            <v-toolbar color="primary" dark :class="dialogHeadingClasses()">
                <v-icon v-text="icons.mdiCarBrakeAlert" class="mr-3"></v-icon>
                {{ $gettext('SOS') }}
                <v-spacer></v-spacer>
                <v-icon class="mr-2" @click.native.stop="closeSosDialog()" v-text="icons.mdiClose" v-show="!showProgressBar"></v-icon>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text>
                <v-container>
                    <v-form class="my-3 py-0">

                        <v-row>
                            <v-col>
                                <div class="text-h6" v-text="$gettext('Get temporary and immediate access to internet without any restrictions.')"></div>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col>
                                <div class="subtitle-1" v-text="$gettext('How much time do you need?')"></div>

                                <v-slider
                                    hint=""
                                    max="240"
                                    min="15"
                                    step="15"
                                    ticks="always"
                                    tick-size="4"
                                    v-model="sosMinutes"
                                ></v-slider>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col v-text="toHoursAndMinutes(sosMinutes) + ' hours'" class="text-h4"></v-col>
                        </v-row>
                    </v-form>
                </v-container>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions color="secondary">
                <v-spacer></v-spacer>
                <v-btn class="primary" @click.native.stop="closeSosDialog()">
                    {{ $gettext('Close') }}
                </v-btn>
                <v-btn class="primary" type="submit">
                    {{ $gettext('Enable SOS') }}
                </v-btn>
            </v-card-actions>
        </v-card>
        <snackbar ref="snackbar"></snackbar>
    </v-dialog>
</template>
<style type="text/scss">

.add-rule-radio-margin .v-input--selection-controls {
    margin-top: 0;
}

</style>

<script>

import MixinDialog from '@/mixins/MixinDialog'
import MixinIcon from '@/mixins/MixinIcon'
import MixinStringManipulation from '@/mixins/MixinStringManipulation'
import MixinGenericComponent from '@/mixins/generic/MixinGenericComponent'
import MixinAdminOptions from '@/mixins/MixinAdminOptions'

export default {
    name: 'DialogSos',
    mixins: [MixinAdminOptions, MixinDialog, MixinIcon, MixinStringManipulation, MixinGenericComponent],
    props: {
        params: {
            required: true,
            type: Object | Array,
        },
    },
    data () {
        return {
            sosMinutes: 15,
        }
    },
    methods: {

        padTo2Digits (num) {
            return num.toString().padStart(2, '0')
        },

        toHoursAndMinutes (totalMinutes) {
            const minutes = totalMinutes % 60
            const hours = Math.floor(totalMinutes / 60)

            return `${hours}:${this.padTo2Digits(minutes)}`
        },

        closeSosDialog () {
            let self = this
            let appComponent = self.genericComponentGetComponent('App')
            appComponent.closeDialog('sosDialog')
        },

    },

}
</script>
